import React, {Component} from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import CardDetails from '../../components/payment/CardDetails'
import UpdateCardDetails from '../../components/payment/UpdateCardDetails'
import {
    onCancelUpdatingCardDetails,
    onCardSetupFailed,
    onCardSetupSuccess,
    onFetchCardDetails,
    onSaveCardDetails,
    onSwitchToUpdateCardDetails
} from '../../modules/payment/payment'
import {Elements} from 'react-stripe-elements';

class PaymentDetails extends Component {

    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.onFetchCardDetails()
    }

    handleCardSetupSuccess = (setupIntent, nextAction) => {
        this.props.onCardSetupSuccess(setupIntent, nextAction);
    }

    handleCardSetupFailed = (err) => {
        this.props.onCardSetupFailed(err);
    }

    handleSaveCardDetails = () => {
        this.props.onSaveCardDetails();
    }

    handleCancelUpdatingCardDetails = () => {
        this.props.onCancelUpdatingCardDetails();
    }

    handleUpdateCardDetails = () => {
        this.props.onSwitchToUpdateCardDetails();
    }

    render() {
        const { initialEntry, cardDetails, loadingCardDetails, editing, creatingCard, cardCreationError } = this.props;
        if(editing) {
            return (
                <Elements>
                    <UpdateCardDetails initial={initialEntry} creating={creatingCard} error={cardCreationError} onSave={this.handleSaveCardDetails} onCancel={ cardDetails ? this.handleCancelUpdatingCardDetails : null} onCardSetupSuccess={this.handleCardSetupSuccess} onCardSetupFailed={this.handleCardSetupFailed}/>
                </Elements>
            )
        } else {
            return (
                <CardDetails loading={loadingCardDetails} card={cardDetails} onEdit={this.handleUpdateCardDetails}/>
            );
        }
    }
}

const mapStateToProps = state => (
    {...state.payment}
)

const mapDispatchToProps = dispatch => bindActionCreators({
    onFetchCardDetails,
    onSaveCardDetails,
    onCancelUpdatingCardDetails,
    onCardSetupSuccess,
    onCardSetupFailed,
    onSwitchToUpdateCardDetails
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentDetails)
